export {};
//# sourceMappingURL=type-metadata.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/metadata/type-metadata.interface.js
// module id = 800
// module chunks = 3